import { generateTestId } from "@client-shared";

export const setVariantInfoBlockTestId = (identifier: string): string => generateTestId("VariantInfoBlock", identifier);

export const setVariantInfoBlockOverrideTestId = (attribute: string): string => generateTestId("VariantInfoBlock", `override-${attribute}`);
